import { ObjectCreationWizard } from "@/components/object/ObjectCreationWizard";
import { Link } from "react-router-dom";
import { ArrowLeft } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function ObjectWizardPage() {
  return (
    <div className="min-h-screen bg-background">
      <header className="border-b px-4 py-3 flex items-center gap-3">
        <Button variant="ghost" size="sm" asChild>
          <Link to="/">
            <ArrowLeft className="h-4 w-4 mr-1" />
            На карту
          </Link>
        </Button>
        <span className="text-sm text-muted-foreground">Создание объекта</span>
      </header>
      <ObjectCreationWizard />
    </div>
  );
}
